<template>
  <div v-if="users.length">
    <div class="card card--white">
      <div class="card--container">
        <h3>Impersonate</h3>
        <h-select :items="users" v-model="impersonate" item-value="email" item-text="email" label="Users" outline>
        </h-select>
        <h-btn class="primary" @click="go">Impersonate</h-btn>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/services/api/store";
import User from "@/services/api/authUser";
import titleCase from "@/services/titleCase";

export default {
  data() {
    return {
      users: [],
      impersonate: undefined
    };
  },
  created() {
    store.findAll("User", { all: true }).then(users => {
      this.users = users;
    });
  },
  methods: {
    getName(u) {
      return titleCase(`${u.first_name} ${u.last_name}`);
    },
    go() {
      User.impersonate(this.impersonate).then(() => {
        window.location.reload();
      });
    }
  }
};
</script>

<style>
</style>
